<div *ngIf="hasAdminRight" fxLayout="column">
  <div fxFlex="auto" class="setting-header">
    {{
      (type === 'creationform' ? 'l10n_creationForm' : 'l10n_wizard')
        | translate
    }}
  </div>
  <div fxFlex="auto" class="setting-card">
    <mat-card>
      <mat-card-content>
        <div fxLayout="column" fxLayoutAlign="start start">
          <div
            fxFlex="auto"
            fxLayout="row wrap"
            fxLayoutAlign="start center"
            class="config-dialog-outlined"
          >
            <div fxFlex="200px" class="profile-info" style="margin-right: 20px">
              {{ 'l10n_availableWizard' | translate }}
            </div>
            <div fxFlex="auto" style="margin-right: 30px; width: 260px">
              <mat-form-field style="width: 100%; margin-top: 10px">
                <mat-label>{{ 'l10n_selectWizard' | translate }}</mat-label>
                <mat-select
                  [(value)]="selectedWizard"
                  (selectionChange)="onWizardSelectionChange()"
                  style="font-size: 16px"
                >
                  <mat-option>--</mat-option>
                  <mat-option
                    *ngFor="let wizard of availableWizards"
                    [value]="wizard"
                  >
                    {{ wizard.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex="none" fxLayout="row" fxLayoutGap="20px">
              <button
                mat-stroked-button
                [disabled]="!selectedWizard || availableWizards.length <= 0"
                (click)="onRemoveWizard()"
                color="warn"
              >
                {{ 'key_delete' | translate }}
              </button>
              <button
                mat-stroked-button
                (click)="onAddWizard()"
                color="primary"
              >
                {{ 'key_add' | translate }}
              </button>
              <mat-divider [vertical]="true" style="height: 30px"></mat-divider>
              <button
                mat-stroked-button
                [disabled]="!selectedWizard || availableWizards.length <= 0"
                color="primary"
                (click)="onExportWizard()"
              >
                <div
                  fxLayout="row"
                  fxLayoutAlign="center center"
                  fxLayoutGap="10px"
                >
                  <div>{{ 'key_exportToClipboard' | translate }}</div>
                  <span class="material-icons-outlined">download</span>
                </div>
              </button>
              <button
                mat-stroked-button
                color="primary"
                (click)="onImportWizard()"
              >
                <div
                  fxLayout="row"
                  fxLayoutAlign="center center"
                  fxLayoutGap="10px"
                >
                  <div>{{ 'key_importFromClipboard' | translate }}</div>
                  <span class="material-icons-outlined">upload</span>
                </div>
              </button>
            </div>
          </div>
          <div fxFlex="auto">
            <mat-divider></mat-divider>
          </div>
          <div
            *ngIf="showWizard"
            fxFlex="auto"
            fxLayout="row wrap"
            fxLayoutGap="20px"
            style="margin-top: 20px"
            class="config-dialog-outlined"
          >
            <div fxFlex="200px" style="font-weight: 400; padding-top: 15px">
              <mat-checkbox [(ngModel)]="selectedWizard.hideButtons">{{
                'l10n_hideButtons' | translate
              }}</mat-checkbox>
            </div>
            <div *ngIf="type === 'creationform'" fxFlex="none">
              <mat-form-field [appearance]="'outline'">
                <mat-label>{{ 'key_resourceType' | translate }}</mat-label>
                <input matInput disabled [value]="selectedWizard.objectType" />
              </mat-form-field>
            </div>
            <div fxFlex="none">
              <mat-form-field
                [appearance]="'outline'"
                [style.margin-left.px]="type === 'creationform' ? 0 : 12"
              >
                <mat-label>{{ 'key_type' | translate }}</mat-label>
                <mat-select [(ngModel)]="selectedWizard.type">
                  <mat-option
                    *ngFor="let option of wizardTypes"
                    [value]="option"
                    >{{ option }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex="none">
              <mat-form-field [appearance]="'outline'">
                <mat-label>{{ 'key_displayName' | translate }}</mat-label>
                <input matInput [(ngModel)]="selectedWizard.displayName" />
              </mat-form-field>
            </div>
          </div>
          <div
            *ngIf="showWizard"
            fxFlex="auto"
            fxLayout="row wrap"
            fxLayoutGap="20px"
            style="margin-top: 20px"
            class="config-dialog-outlined"
          >
            <div
              *ngIf="type === 'creationform'"
              fxFlex="200px"
              style="font-weight: 400; padding-top: 15px"
            >
              <mat-checkbox
                [ngModel]="selectedWizard.navigateToResource"
                [indeterminate]="
                  selectedWizard.navigateToResource === undefined ||
                  selectedWizard.navigateToResource === null
                "
                (change)="onSetNavigateToResource()"
                >{{ 'key_navigateToResource' | translate }}</mat-checkbox
              >
            </div>
            <div *ngIf="type === 'creationform'" fxFlex="none">
              <mat-form-field [appearance]="'outline'">
                <mat-label>{{ 'key_navigationKey' | translate }}</mat-label>
                <input matInput [(ngModel)]="selectedWizard.navigationKey" />
              </mat-form-field>
            </div>
            <div fxFlex="none">
              <mat-form-field [appearance]="'outline'">
                <mat-label>{{ 'key_stateCardIconText' | translate }}</mat-label>
                <input matInput [(ngModel)]="selectedWizard.icon" />
              </mat-form-field>
            </div>
            <div fxFlex="none">
              <mat-form-field [appearance]="'outline'">
                <mat-label>{{ 'key_width' | translate }}</mat-label>
                <input
                  matInput
                  type="number"
                  [(ngModel)]="selectedWizard.width"
                />
              </mat-form-field>
            </div>
            <div fxFlex="none">
              <mat-form-field [appearance]="'outline'">
                <mat-label>{{ 'key_canSubmitAtStep' | translate }}</mat-label>
                <input
                  matInput
                  type="number"
                  [(ngModel)]="selectedWizard.canSubmitAtStep"
                />
              </mat-form-field>
            </div>
          </div>
          <div *ngIf="showWizard; else noConfig">
            <div
              *ngIf="isCloud && type !== 'creationform'"
              fxLayout="column"
              class="config-dialog-outlined"
            >
              <div
                style="margin-top: 10px; margin-bottom: 10px; font-weight: 400"
              >
                <mat-checkbox
                  [(ngModel)]="selectedWizard.executeWorkflowTemplate"
                  (change)="onExecuteWorkflowTemplateChange()"
                  matTooltip="{{
                    'key_executeWorkflowTemplateDes' | translate
                  }}"
                  >{{ 'key_executeWorkflowTemplate' | translate }}
                </mat-checkbox>
              </div>
              <div
                *ngIf="selectedWizard.executeWorkflowTemplate"
                fxFlex="auto"
                fxLayout="row wrap"
                fxLayoutGap="20px"
                style="margin-top: 10px"
              >
                <div
                  fxflex="auto"
                  fxLayout="column"
                  style="padding-bottom: 15px; padding-top: 5px"
                >
                  <div
                    *ngIf="selectedWizard.executeWorkflowTemplate"
                    fxFlex="auto"
                    fxLayout="row"
                  >
                    <form
                      #workflowTemplateForm="ngForm"
                      autocomplete="off"
                      (keydown.enter)="$event.preventDefault()"
                    >
                      <div fxLayout="column">
                        <app-editor-identity
                          #idpWorkflowWorflow
                          name="idpWorkflowTemplate"
                          [creationMode]="true"
                          [config]="idpWorkflowConfig"
                          [(ngModel)]="templateResource"
                          (valueChange)="onWorkflowChange()"
                          style="width: 650px"
                        ></app-editor-identity>
                        <div
                          *ngIf="selectedWizard.workflowTemplate"
                          fxFlex="auto"
                          fxLayout="row"
                          style="font-weight: 400; padding-bottom: 15px"
                        >
                          <div fxlayout="column">
                            <div
                              fxLayout="row"
                              fxLayoutAlign="start center"
                              style="padding: 5px; margin-bottom: 2px"
                            >
                              {{ 'key_inputParameters' | translate }}
                            </div>
                            <div
                              *ngFor="
                                let parameter of parameterConfig;
                                let i = index
                              "
                              fxLayout="row"
                              fxLayoutAlign="start center"
                              class="background-bg-color"
                              style="padding: 5px; margin-bottom: 2px"
                            >
                              <div
                                fxFlex="200px"
                                fxLayout="column"
                                style="margin-right: 20px"
                              >
                                <div>
                                  {{ parameter.displayname | translate }}
                                </div>
                                <div
                                  class="accent-text-color"
                                  style="
                                    font-size: 0.75em;
                                    margin-top: 5px;
                                    font-weight: 400;
                                  "
                                >
                                  {{ parameter.description | translate }}
                                </div>
                              </div>
                              <mat-form-field
                                fxFlex="auto"
                                style="font-size: 12px; margin-right: 20px"
                              >
                                <mat-label>{{
                                  'key_wftInputSource' | translate
                                }}</mat-label>
                                <input
                                  name="parameterValue_{{ i }}"
                                  #fieldParameterValue="ngModel"
                                  matInput
                                  matTooltip="{{
                                    'key_wizardInputParameterTooltip'
                                      | translate
                                  }}"
                                  [(ngModel)]="parameter.paramValue"
                                  [required]="parameter.required"
                                  (change)="onValueChange()"
                                />
                                <mat-error
                                  *ngIf="
                                    fieldParameterValue.hasError('required')
                                  "
                                  >{{
                                    'key_valueRequired' | translate
                                  }}</mat-error
                                >
                              </mat-form-field>
                              <div
                                fxFlex="80px"
                                style="
                                  margin-left: 20px;
                                  padding-left: 5px;
                                  border-left: solid 4px darkseagreen;
                                  font-size: 12px;
                                "
                              >
                                {{ parameter.datatype }}
                              </div>
                              <div
                                fxFlex="80px"
                                style="
                                  margin-left: 20px;
                                  padding-left: 5px;
                                  border-left: solid 4px;
                                  font-size: 12px;
                                "
                                [style.border-left-color]="
                                  parameter.required ? 'red' : 'darkseagreen'
                                "
                              >
                                {{ 'key_allowNull' | translate }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div fxFlex="auto">
                <mat-divider
                  style="width: 100%; margin-bottom: 10px; margin-bottom: 10px"
                ></mat-divider>
              </div>
            </div>
            <div
              fxFex="auto"
              style="
                margin-top: 20px;
                margin-bottom: 60px;
                padding: 20px;
                border: solid 5px #eeeeee;
              "
              [style.width.px]="selectedWizard.width"
            >
              <app-popup-wizard
                #popupWizard
                [dialogMode]="false"
                [configMode]="true"
                [popupType]="type"
                [saveButtonDisabled]="saveButtonDisabled"
                (valueSave)="onWizardSaved()"
              ></app-popup-wizard>
            </div>
          </div>
          <ng-template #noConfig>
            <div
              fxLayout="column"
              fxLayoutAlign="center center"
              style="width: 100%; margin: 80px 0"
            >
              <mat-icon
                fxFlex="none"
                style="font-size: 100px; width: 100px; color: #cccccc"
                >contact_support</mat-icon
              >
              <div
                fxFlex="none"
                style="
                  margin-top: 50px;
                  padding-top: 50px;
                  font-size: 18px;
                  color: #b0b0b0;
                "
              >
                {{ 'key_noConfiguration' | translate }}
              </div>
            </div>
          </ng-template>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
